export const orange = {
  1: { value: { base: '{colors.orange.light.1}', _dark: '{colors.orange.dark.1}' } },
  2: { value: { base: '{colors.orange.light.2}', _dark: '{colors.orange.dark.2}' } },
  3: { value: { base: '{colors.orange.light.3}', _dark: '{colors.orange.dark.3}' } },
  4: { value: { base: '{colors.orange.light.4}', _dark: '{colors.orange.dark.4}' } },
  5: { value: { base: '{colors.orange.light.5}', _dark: '{colors.orange.dark.5}' } },
  6: { value: { base: '{colors.orange.light.6}', _dark: '{colors.orange.dark.6}' } },
  7: { value: { base: '{colors.orange.light.7}', _dark: '{colors.orange.dark.7}' } },
  8: { value: { base: '{colors.orange.light.8}', _dark: '{colors.orange.dark.8}' } },
  9: { value: { base: '{colors.orange.light.9}', _dark: '{colors.orange.dark.9}' } },
  10: { value: { base: '{colors.orange.light.10}', _dark: '{colors.orange.dark.10}' } },
  11: { value: { base: '{colors.orange.light.11}', _dark: '{colors.orange.dark.11}' } },
  12: { value: { base: '{colors.orange.light.12}', _dark: '{colors.orange.dark.12}' } },
  a1: { value: { base: '{colors.orange.light.a1}', _dark: '{colors.orange.dark.a1}' } },
  a2: { value: { base: '{colors.orange.light.a2}', _dark: '{colors.orange.dark.a2}' } },
  a3: { value: { base: '{colors.orange.light.a3}', _dark: '{colors.orange.dark.a3}' } },
  a4: { value: { base: '{colors.orange.light.a4}', _dark: '{colors.orange.dark.a4}' } },
  a5: { value: { base: '{colors.orange.light.a5}', _dark: '{colors.orange.dark.a5}' } },
  a6: { value: { base: '{colors.orange.light.a6}', _dark: '{colors.orange.dark.a6}' } },
  a7: { value: { base: '{colors.orange.light.a7}', _dark: '{colors.orange.dark.a7}' } },
  a8: { value: { base: '{colors.orange.light.a8}', _dark: '{colors.orange.dark.a8}' } },
  a9: { value: { base: '{colors.orange.light.a9}', _dark: '{colors.orange.dark.a9}' } },
  a10: { value: { base: '{colors.orange.light.a10}', _dark: '{colors.orange.dark.a10}' } },
  a11: { value: { base: '{colors.orange.light.a11}', _dark: '{colors.orange.dark.a11}' } },
  a12: { value: { base: '{colors.orange.light.a12}', _dark: '{colors.orange.dark.a12}' } },
}
